export default __webpack_public_path__ + "static/media/search-image.a3c945f6.svg";